import { getP } from 'redux-polyglot'
import {
  REGISTER_INPUT_EMAIL,
  REGISTER_INPUT_PASSWORD,
  REGISTER_INPUT_USERNAME,
  REGISTER_INPUT_REFFERAL_ID,
  REGISTER_INPUT_PHONE,
  FETCH_REGISTER_TEXT_REQUEST,
  ERORR_PASSWORD,
  ERORR_PHONE,
  ERORR_USERNAME,
  ERORR_EMAIL,
  ERORR_REFFERAL_ID,
  DISABLE_REGISTER,
} from '../constants/register'
import api from '../libs/api'

/**
 * Actions for performing the register
 */
export const REGISTER_REQUEST = 'AUTH/REGISTER/REQUEST'
export const REGISTER_SUCCESS = 'AUTH/REGISTER/SUCCESS'
export const REGISTER_FAILURE = 'AUTH/REGISTER/FAILURE'

const registerRequest = () => ({
  type: REGISTER_REQUEST,
})

const registerSuccess = () => ({
  type: REGISTER_SUCCESS,
})

const registerFailure = (error, errors) => {
  const payload = error instanceof Error ? error : new Error(error)
  payload.errors = errors
  return {
    type: REGISTER_FAILURE,
    payload: payload,
    error: true,
  }
}

export const register = (username, email, password, phone, refferal_id) => (
  dispatch,
  getState
) => {
  dispatch(registerRequest())
  return api
    .register(username, email, password, phone, refferal_id)
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          return dispatch(registerSuccess())
        } else {
          return dispatch(registerFailure(response.reason, response.errors))
        }
      },
      () =>
        dispatch(
          registerFailure(
            getP(getState()).t('tv_auth.error_account_registration', {
              _: 'An error occurred while registering your new account',
            })
          )
        )
    )
}

/**
 * Actions related to keyboard on register screen
 */
export const FOCUS_INPUT = 'REGISTER/FOCUS_INPUT'
export const UPDATE_INPUT = 'REGISTER/UPDATE_INPUT'
export const DELETE_INPUT = 'REGISTER/DELETE_INPUT'
export const ERROR_INPUT = 'REGISTER/ERROR_INPUT'
export const SET_STATUS = 'REGISTER/SET_STATUS'
export const RESET = 'REGISTER/RESET'

export const focusInput = focusedInput => {
  let newFocusedInput
  switch (focusedInput) {
    case REGISTER_INPUT_USERNAME:
    case REGISTER_INPUT_EMAIL:
    case REGISTER_INPUT_PASSWORD:
    case REGISTER_INPUT_REFFERAL_ID:
    case REGISTER_INPUT_PHONE:
      newFocusedInput = focusedInput
      break
    default:
      newFocusedInput = REGISTER_INPUT_USERNAME
  }

  return {
    type: FOCUS_INPUT,
    payload: {
      focusedInput: newFocusedInput,
    },
  }
}

export const updateInput = newKey => ({
  type: UPDATE_INPUT,
  payload: {
    newKey,
  },
})

export const deleteInput = () => ({
  type: DELETE_INPUT,
})

export const errorInput = (input, error) => ({
  type: ERROR_INPUT,
  payload: {
    input,
    error,
  },
})

export const setStatus = status => ({
  type: SET_STATUS,
  payload: {
    status,
  },
})

export const reset = () => ({
  type: RESET,
})

const fetchRegisterTextRequest = registerText => ({
  type: FETCH_REGISTER_TEXT_REQUEST,
  payload: {
    registerText,
  },
})

// Text api for register
export const loadRegisterText = () => dispatch => {
  return api
    .getRegisterText()
    .then(response => response.json())
    .then(response => {
      if (response.status === 200) {
        return dispatch(fetchRegisterTextRequest(response.dictionary.register))
      }
    })
}

// Validation
const errorUsername = error => ({
  type: ERORR_USERNAME,
  errMessage: error !== 'ok' ? error : '',
})

export const verifyUsername = (username, timestamp) => dispatch => {
  return api
    .postRegisterUsername(username, timestamp)
    .then(response => response.json())
    .then(response => {
      dispatch(errorUsername(response.content))
    })
}

const errorEmail = error => ({
  type: ERORR_EMAIL,
  errMessage: error !== 'ok' ? error : '',
})

export const verifyEmail = (email, timestamp) => dispatch => {
  return api
    .postRegisterEmail(email, timestamp)
    .then(response => response.json())
    .then(response => {
      dispatch(errorEmail(response.content))
    })
}

const errorRefferalId = error => ({
  type: ERORR_REFFERAL_ID,
  errMessage: error !== 'ok' ? error : '',
})

export const verifyRefferalId = (refferalId, timestamp) => dispatch => {
  return api
    .postRegisterRefferalId(refferalId, timestamp)
    .then(response => response.json())
    .then(response => {
      dispatch(errorRefferalId(response.content))
    })
}

const errorPassword = error => ({
  type: ERORR_PASSWORD,
  errMessage: error,
})

export const verifyPassword = password => (dispatch, state) => {
  if (password.length < 6) {
    dispatch(errorPassword('Password must be at least 6 characters.', state))
  } else {
    dispatch(errorPassword('', state))
  }
}

const errorPhone = error => ({
  type: ERORR_PHONE,
  errMessage: error,
})

export const verifyPhone = phone => (dispatch, state) => {
  const phoneRegex = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/
  const phoneTest = phoneRegex.test(phone)

  if (!phoneTest) {
    dispatch(
      errorPhone(
        'Invalid phone number. Format: exactly 10 digits (no letters, country code, ext). For example, (123)123-1234.',
        state
      )
    )
  } else {
    dispatch(errorPhone(''))
  }
}

export const isDisabledRegister = () => (dispatch, getState) => {
  const {
    register: {
      passwordErrMessage,
      phoneErrMessage,
      usernameErrMessage,
      emailErrMessage,
    },
  } = getState()
  const errorArr = [
    passwordErrMessage,
    phoneErrMessage,
    usernameErrMessage,
    emailErrMessage,
  ]
  const isValideArr = errorArr.some(item => item || item === null)

  if (isValideArr) {
    dispatch({
      type: DISABLE_REGISTER,
      disabled: true,
    })
  } else {
    dispatch({
      type: DISABLE_REGISTER,
      disabled: false,
    })
  }
}
